var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.249 7.293A1.486 1.486 0 0 0 2.94 8.6a37.359 37.359 0 0 0 0 8.68c.078.686.623 1.23 1.309 1.307 2.94.327 8.562.327 11.502 0a1.486 1.486 0 0 0 1.309-1.307 37.355 37.355 0 0 0 0-8.68 1.486 1.486 0 0 0-1.309-1.307",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.168v10.64M13.364 8.92c-1.022 1.291-1.718 1.892-2.756 2.678a.99.99 0 0 1-1.216 0c-1.037-.786-1.734-1.387-2.756-2.679",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgDownload;